module.exports = "<div class=\"container\">\n  <h1>Welcome to Xpo Authentication Administration Console</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main